
export enum UnitSourceOfIncome {
    EmploymentOrPayrollIncome = 1,
    PartTimeOrContractorIncome = 2,
    InheritancesAndGifts = 3,
    PersonalInvestments = 4,
    BusinessOwnershipInterests = 5,
    GovernmentBenefits = 6
}

export namespace UnitSourceOfIncome {
    export function toString(unitSourceOfIncome: UnitSourceOfIncome): string {
        switch (unitSourceOfIncome) {
            case UnitSourceOfIncome.EmploymentOrPayrollIncome:
                return 'Employment Or Payroll Income';
            case UnitSourceOfIncome.PartTimeOrContractorIncome:
                return 'Part Time Or Contractor Income';
            case UnitSourceOfIncome.InheritancesAndGifts:
                return 'Inheritances And Gifts';
            case UnitSourceOfIncome.PersonalInvestments:
                return 'Personal Investments';
            case UnitSourceOfIncome.BusinessOwnershipInterests:
                return 'Business Ownership Interests';
            case UnitSourceOfIncome.GovernmentBenefits:
                return 'Government Benefits';
            default:
                return '';
        }
    }

    export function listAll(): UnitSourceOfIncome[] {
        return [
            UnitSourceOfIncome.EmploymentOrPayrollIncome,
            UnitSourceOfIncome.PartTimeOrContractorIncome,
            UnitSourceOfIncome.InheritancesAndGifts,
            UnitSourceOfIncome.PersonalInvestments,
            UnitSourceOfIncome.BusinessOwnershipInterests,
            UnitSourceOfIncome.GovernmentBenefits
        ]
    }

    export function parse(str: string): UnitSourceOfIncome {
        return UnitSourceOfIncome[str];
    }
}